import { render, staticRenderFns } from "./MappingSummary.vue?vue&type=template&id=0ebdceb2&"
import script from "./MappingSummary.vue?vue&type=script&lang=js&"
export * from "./MappingSummary.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports